import React from 'react';

interface AccordionProps {
  data: {
    items?: Array<{ title: string; content: string }>;
    allowMultiple?: boolean;
    variant?: string;
    [key: string]: unknown;
  };
  styles?: string;
}

export const Accordion: React.FC<AccordionProps> = ({ data, styles: _styles }) => {
  const { items = [], allowMultiple: _allowMultiple = false, variant: _variant = 'default' } = data ?? {};

  return (
    <div className="">
      <div className="space-y-2">
        {items.map((item, i) => (
          <div key={i} className="border border-[var(--glass-border)]" style={{ borderRadius: 'var(--style-card-radius, 4px)' }}>
            <button className="w-full px-4 py-2 text-left font-medium flex justify-between bg-[var(--surface-2,#f9fafb)] text-[var(--text-primary)]">
              {item.title}
              <span>▼</span>
            </button>
            <div className="px-4 py-2 text-sm text-[var(--text-secondary)]">{item.content}</div>
          </div>
        ))}
      </div>
    </div>
  );
};
